module.exports = __webpack_public_path__ + "img/img11.3fbbd49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img11.png
// module id = 233
// module chunks = 0